import { getToken } from './auth.js'
import axios from 'axios'
import { baseUrl } from '../config.js'

export function headers() {
  return {
    headers: { Authorization: `Bearer ${getToken()}` },
  }
}


//* GIN REQ

export function getAllGins() {
  return axios.get(`${baseUrl}/gins`)
}

export function getGin(ginId) {
  return axios.get(`${baseUrl}/gins/${ginId}`)
}

//* WISH / COMMENT REQ

export function wishGin(ginId) {
  return axios.post(`${baseUrl}/gins/${ginId}/like/`, null, headers())
}

export function createReview(ginId, formData) {
  return axios.post(`${baseUrl}/gins/${ginId}/comments/`, formData, headers())
}

//* AUTH REQ

export function userProfile(userId) {
  return axios.get(`${baseUrl}/auth/profile/${userId}`, headers())
}